import { tryGetAppHostedAtRoot } from '@office-start/route-utility';
export function getResolvedUrl(url, featureGates, featureSettings) {
    var _a, _b, _c;
    // Handle hosting mos app at root
    // Mos app url look like https://www.microsoft.com/m365apps/{someGuidAppId}
    // If the app should be hosted at root, need to remove /m365apps and replace the guid id with friendly app id
    if (((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.mosAppHostedAtRootGates) === null || _a === void 0 ? void 0 : _a.mosAppHostedAtRootEnabled) &&
        url.indexOf('/m365apps') > -1) {
        var supportedApps = (_c = (_b = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.routing) === null || _b === void 0 ? void 0 : _b.mosAppsHostedAtRoot) === null || _c === void 0 ? void 0 : _c.split(',');
        // friendlyAppId is available when the app should be hosted at root
        var friendlyAppId = tryGetAppHostedAtRoot(url, supportedApps, true);
        if (friendlyAppId) {
            var guidAppId = tryGetAppHostedAtRoot(url, supportedApps, false);
            url = url
                .replace('/m365apps', '')
                .replace("/".concat(guidAppId), "/".concat(friendlyAppId));
        }
    }
    return url;
}
//# sourceMappingURL=getResolvedUrl.js.map